import Cookies from "js-cookie";
import store from "../store/index"
import MAPDATA from "../assets/map/dadukou.json"
export let formatRiskLevel = (level = 0) => {
  let map = new Map([
    [0, `基本健康人群`],
    [1, `基本健康人群`],
    [2, `专项关爱人群`],
    [3, `重点关爱人群`],
  ]);
  return map.get(level);
}
export const sessionKey = "u-merchant-info";
export const TokenKey = "authorized-merchant-token";
export const getToken = () => {
  // 此处与`TokenKey`相同，此写法解决初始化时`Cookies`中不存在`TokenKey`报错
  return Cookies.get(TokenKey) ?
    JSON.parse(Cookies.get(TokenKey)) :
    sessionStorage.getItem(sessionKey);
}
export const formatConfig = () => {
  let largeConfig = store.state.login.largeConfig
  if (!largeConfig) return;
  let subDistricts = largeConfig.subDistricts || [];

  let list = MAPDATA.features.filter(v => subDistricts.includes(v.properties.name))
  return {
    ...MAPDATA,
    features: list
  }
}
/*判断屏幕宽高比是否为16:9*/
export const isScreen16to9 = () => {
  return window.screen.height / window.screen.width === 9 / 16;
}
